var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"id":"loading-page"}},[_c('v-container',{staticClass:"mt-10"},[_c('v-col',{staticClass:"text-center"},[_c('strong',[_vm._v("Aguarde...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }